export default __webpack_public_path__ + "trending-down-afa9d5f1936bdf41f50e3458f8f9bcd4.svg";